import { AxiosError } from "axios";
import { showNotification } from "../../common/actionCreators/dispatchNotification";
import apiClient from "../../common/api/apiClient";
import { ApiError } from "../../common/api/apiResponse";
import { FacilityExtraDto } from "./visitorInformation.dtos";

const informationUrl = '/visitorInformation/extras/';

export const getFacilityInfoApi = async () => {
    return await apiClient.get(informationUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving facility information.', 'error');
        }
        throw err;
    });
};

export const getContentApi = async () => {
    return await apiClient.get(informationUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving facility content.', 'error');
        }
        throw err;
    });
};

export const updateFacilityInfoApi = async (request: FacilityExtraDto[]) => {
    return await apiClient.put(informationUrl, request)
      .then((res) => {
        showNotification("Facility information updated", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while updating facility information.', 'error');
        }
        throw err;
      });
};
  
export const createFacilityInfoApi = async (request: FacilityExtraDto[]) => {
    return await apiClient.post(informationUrl, request)
      .then((res) => {
        showNotification("Facility information created", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while creating facility information.', 'error');
        }
        throw err;
      });
};